import { render, staticRenderFns } from "./privacyStatement.vue?vue&type=template&id=242cd997"
import script from "./privacyStatement.vue?vue&type=script&lang=js"
export * from "./privacyStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports